import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const definitiveSurveyRunListMap = new Map();

definitiveSurveyRunListMap.set(KnowEdmTableData.DepthMD, {
  key: KnowEdmTableData.DepthMD,
  label: RecognisedHeaderLabels.DepthMD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.Inclination, {
  key: KnowEdmTableData.Inclination,
  label: RecognisedHeaderLabels.Inclination,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.Azimuth, {
  key: KnowEdmTableData.Azimuth,
  label: RecognisedHeaderLabels.Azimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.DepthTVD, {
  key: KnowEdmTableData.DepthTVD,
  label: RecognisedHeaderLabels.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.Easting, {
  key: KnowEdmTableData.Easting,
  label: RecognisedHeaderLabels.Easting,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.Northing, {
  key: KnowEdmTableData.Northing,
  label: RecognisedHeaderLabels.Northing,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.LocalPositionEW, {
  key: KnowEdmTableData.LocalPositionEW,
  label: RecognisedHeaderLabels.LocalPositionEW,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.LocalPositionNS, {
  key: KnowEdmTableData.LocalPositionNS,
  label: RecognisedHeaderLabels.LocalPositionNS,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.VerticalSection, {
  key: KnowEdmTableData.VerticalSection,
  label: RecognisedHeaderLabels.VerticalSection,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.Dogleg, {
  key: KnowEdmTableData.Dogleg,
  label: RecognisedHeaderLabels.Dogleg,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.Build, {
  key: KnowEdmTableData.Build,
  label: RecognisedHeaderLabels.Build,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.Turn, {
  key: KnowEdmTableData.Turn,
  label: RecognisedHeaderLabels.Turn,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

definitiveSurveyRunListMap.set(KnowEdmTableData.ToolFace, {
  key: KnowEdmTableData.ToolFace,
  label: RecognisedHeaderLabels.ToolFace,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

export { definitiveSurveyRunListMap as definitiveSurveyListMap };
